module.exports = __webpack_public_path__ + "static/media/3.7b9f1d9a.webp";